import apiClient from './api_client_requests';

export default config => {
    return async payload => {
        let result = await apiClient(config).apiMethod({
            method: 'GetGameOver',
            args: {},
        });

        return result;
    };
};
